import React from "react";
import {Row, Col, Form, Input, Select} from 'antd';

const {Option} = Select;

const TabOpcoesPDV = ({dataTab})=> {

    // imprimeItemComanda
    
    return (
        <Row gutter={[16, 16]}>
           
           <Col span={8}>
                <Form.Item label="Imprime no Pedido PDV?" name="imprimeItemComanda">
                    <Select data-tab={dataTab}>
                        <Option value={"SIM"}>SIM</Option>
                        <Option value={"NAO"}>NAO</Option>
                    </Select>
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item label="Numero da Impressora de PDV" name="numeroImpressoraComanda">
                    <Input  data-tab={dataTab} />
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item label="Exibe produto no PDV?" name="exibeProdutoPDV">
                    <Select data-tab={dataTab}>
                        <Option value={"SIM"}>SIM</Option>
                        <Option value={"NAO"}>NAO</Option>
                    </Select>
                </Form.Item>
            </Col>
            
        </Row>
    );
}

export {TabOpcoesPDV  };